import React, { createContext, useContext, useState } from "react";

const GoalContext = createContext();

export const useGoal = () => useContext(GoalContext);

export const GoalProvider = ({ children }) => {
  const [goalID, setGoalID] = useState(null);
  const [goalTitle, setGoalTitle] = useState(null);
  const [goalEndDate, setGoalEndDate] = useState(null);
  const [goalEventDetails, setGoalEventDetails] = useState(null);
  const [goalTags, setTags] = useState(null);
  const [goalCategory, setCategory] = useState(null);
  const [goalCapture, setCapture] = useState(null);

  return (
    <GoalContext.Provider
      value={{
        goalID,
        setGoalID,
        goalTitle,
        setGoalTitle,
        goalEndDate,
        setGoalEndDate,
        goalEventDetails,
        setGoalEventDetails,
        goalTags,
        setTags,
        goalCategory,
        setCategory,
        goalCapture,
        setCapture,
      }}
    >
      {children}
    </GoalContext.Provider>
  );
};
